export * from '@primeuix/themes/nora/datatable';
export { default } from '@primeuix/themes/nora/datatable';
